var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 51,
    viewBox: "0 0 81 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5751_23679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2224 50.1506C62.3138 50.1506 80.2224 46.2212 80.2224 41.3741C80.2224 36.527 62.3138 32.5977 40.2224 32.5977C18.131 32.5977 0.222412 36.527 0.222412 41.3741C0.222412 46.2212 18.131 50.1506 40.2224 50.1506Z",
    fill: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9724 17.2619L56.2899 2.84093C55.6812 1.85796 54.7924 1.26367 53.8562 1.26367H26.5887C25.6524 1.26367 24.7637 1.85796 24.1549 2.83968L11.4724 17.2632V28.8469H68.9724V17.2619Z",
    stroke: "#F5B0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2387 21.2373C52.2387 19.225 53.4812 17.5638 55.0224 17.5625H68.9724V40.3023C68.9724 42.9641 67.3224 45.1457 65.2849 45.1457H15.1599C13.1224 45.1457 11.4724 42.9628 11.4724 40.3023V17.5625H25.4224C26.9637 17.5625 28.2062 19.2213 28.2062 21.2336V21.2612C28.2062 23.2735 29.4624 24.8984 31.0024 24.8984H49.4424C50.9824 24.8984 52.2387 23.2584 52.2387 21.2461V21.2373Z",
    fill: "#FFF5FA",
    stroke: "#F5B0D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5751_23679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 50.5263,
    fill: "white",
    transform: "translate(0.222412)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBoxIcon);
export default __webpack_public_path__ + "static/media/emptyBoxIcon.2464d63e2b6b875da97210dc30297bdf.svg";
export { ForwardRef as ReactComponent };